import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, EyeIcon, ShieldIcon } from 'lucide-react';
const promises = [{
  icon: <FlameIcon className="w-6 h-6 text-charcoal" data-id="element-211" />,
  title: 'Apaga el ardor nocturno en 12 minutos',
  desc: 'Con la técnica de Hidro-Termia de Contraste, calma los receptores de dolor antes de dormir.'
}, {
  icon: <EyeIcon className="w-6 h-6 text-charcoal" data-id="element-212" />,
  title: 'Detecta el peligro invisible antes de que sea tarde',
  desc: 'Aprende la técnica de "Doble Visión" para encontrar heridas que tus nervios ya no sienten.'
}, {
  icon: <ShieldIcon className="w-6 h-6 text-charcoal" data-id="element-213" />,
  title: 'Protege tus pies de la amputación con un plan diario',
  desc: 'Desde qué zapatos comprar hasta qué suplementos reconstruyen la mielina.'
}];
export function SolutionSection() {
  return <section className="py-20 lg:py-28 bg-emerald-brand text-white relative" data-id="element-214">
      <div className="absolute top-0 left-0 w-full h-1.5 bg-gold-brand" data-id="element-215" />
      <div className="max-w-6xl mx-auto px-5 sm:px-8" data-id="element-216">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-217">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-7 space-y-8" data-id="element-218">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold leading-tight" data-id="element-219">
              Presentamos el Protocolo SOS:{' '}
              <span className="text-gold-brand" data-id="element-220">
                Tu Escudo de Defensa Neural 360°
              </span>
            </h2>
            <p className="text-xl font-body font-light text-emerald-light/90 leading-relaxed" data-id="element-221">
              Esta no es otra guía médica llena de términos complicados. Es un
              manual de supervivencia práctico, diseñado para que tomes el
              control de tu salud desde casa hoy mismo.
            </p>
            <div className="space-y-6 pt-2" data-id="element-222">
              {promises.map((p, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-4" data-id="element-223">
                  <div className="bg-gold-brand p-3 rounded-full flex-shrink-0 mt-0.5" data-id="element-224">
                    {p.icon}
                  </div>
                  <div data-id="element-225">
                    <h3 className="text-xl sm:text-2xl font-heading font-bold" data-id="element-226">
                      {p.title}
                    </h3>
                    <p className="text-base sm:text-lg font-body text-emerald-light/80 mt-1" data-id="element-227">
                      {p.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="lg:col-span-5 flex justify-center" data-id="element-228">
            <img src="https://cdn.magicpatterns.com/uploads/ekytRGEXuK68sJycWWuQ9m/75c6ccc3-9dc9-4e00-8f5e-6eb8271880a7.jpg" alt="Libro Protocolo SOS" className="w-full max-w-xs rounded-xl shadow-2xl border-2 border-gold-brand/30" data-id="element-229" />
          </motion.div>
        </div>
      </div>
    </section>;
}